export default __webpack_public_path__ + "static/media/detail_mobile_14_4.293d96a9.jpg";